/* eslint-disable global-require */
/* eslint-disable import/no-extraneous-dependencies */
import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';

import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { auditApi } from '../../redux/api/auditApi';

import alienVaultReducer from '../../redux/reducers/alienVaultReducer';
import apiKeyReducer from '../../redux/reducers/apiKeyReducer';
import assessmentsReducer from '../../redux/reducers/assessmentsReducer';
import assetReducer from '../../redux/reducers/assetReducer';
import authReducer from '../../redux/reducers/authReducer';
import auvikReducer from '../../redux/reducers/auvikReducer';
import controlGroupTemplatesReducer from '../../redux/reducers/controlGroupTemplatesReducer';
import customerReducer from '../../redux/reducers/customerReducer';
import graphapiReducer from '../../redux/reducers/graphapiReducer';
import jiraTicketsReducer from '../../redux/reducers/jiraTicketsReducer';
import managedbackupReducer from '../../redux/reducers/managedbackupReducer';
import mbdashboardReducer from '../../redux/reducers/mbdashboardReducer';
import mbUsageReducer from '../../redux/reducers/mbUsageReducer';
import modalToggleReducer from '../../redux/reducers/modalToggleReducer';
import monitoringReducer from '../../redux/reducers/monitoringReducer';
import mssentinelReducer from '../../redux/reducers/mssentinelReducer';
import mssReportQueueReducer from '../../redux/reducers/mssReportQueueReducer';
import notificationReducer from '../../redux/reducers/notificationReducer';
import rtlReducer from '../../redux/reducers/rtlReducer';
import sidebarReducer from '../../redux/reducers/sidebarReducer';
import themeReducer from '../../redux/reducers/themeReducer';

import vmReducer from '../../redux/reducers/virtualMachineReducer';
import vmTemplateReducer from '../../redux/reducers/vmTemplateReducer';
import vulnerabilityScansReducer from '../../redux/reducers/vulnerabilityScansReducer';

import quickbooksReducer from '../../redux/reducers/quickbooksReducer';
import redirectReducer from '../../redux/reducers/redirectReducer';
import resourcePermissionReducer from '../../redux/reducers/resourcePermissionReducer';
import resourceReducer from '../../redux/reducers/resourceReducer';
import roleMembershipReducer from '../../redux/reducers/roleMembershipReducer';
import roleReducer from '../../redux/reducers/roleReducer';
import sentinelOneReducer from '../../redux/reducers/sentinelOneReducer';
import servicesReducer from '../../redux/reducers/servicesReducer';
import sharepointReducer from '../../redux/reducers/sharepointReducer';
import sitesReducers from '../../redux/reducers/sitesReducers';
import userReducer from '../../redux/reducers/userReducer';

import alertEmailRecipientsReducer from '../../redux/reducers/alertEmailRecipientsReducer';
import alertReducer from '../../redux/reducers/alertReducer';
import companyNotificationsReducers from '../../redux/reducers/companyNotificationReducer';
import exabeamReducer from '../../redux/reducers/exabeamReducer';
import gpuOneReducer from '../../redux/reducers/gpuOneReducer';
import inventoryReducer from '../../redux/reducers/inventoryReducer';
import K8 from '../../redux/reducers/k8Reducer';
import onboardingReducer from '../../redux/reducers/onboardingReducer';
import oneServerReducer from '../../redux/reducers/oneServerReducer';
import orderReducer from '../../redux/reducers/orderReducer';
import permissionsReducer from '../../redux/reducers/permissionsReducer';
import powerbiReducer from '../../redux/reducers/powerbiReducer';
import privateNetworkReducer from '../../redux/reducers/privateNetworkReducer';
import publicNetworksSlice from '../../redux/reducers/publicNetworkReducer';
import rbacReducer from '../../redux/reducers/rbacReducer';
import skusReducer from '../../redux/reducers/skusReducers';
import ticketNotificationSchemeSlice from '../../redux/reducers/ticketNotificationSchemeReducer';
import virtualRouterReducer from '../../redux/reducers/virtualRouterReducer';

import alertingToolsReducer from '../../redux/reducers/alertingToolsReducer';

// Commented out encryption mechanism
// const secretKey = import.meta.env.VITE_REACT_STN_SECRET_KEY;
// const encryptor = encryptTransform({
//   secretKey,
//   onError: (err) => console.log(err),
// });

// Configuring localforage
// localforage.config({
//   name: 'STN',
//   storeName: 'stnOne',
//   description: 'some description',
// });

const persistConfig = {
	key: 'root',
	storage,
	// transforms: [encryptor],
};

const rootReducer = combineReducers({
	theme: themeReducer,
	sidebar: sidebarReducer,
	rtl: rtlReducer,
	notification: notificationReducer,
	auvik: auvikReducer,
	mssentinel: mssentinelReducer,
	modalToggle: modalToggleReducer,
	controlGroupTemplates: controlGroupTemplatesReducer,
	mssReportQueue: mssReportQueueReducer,
	monitoring: monitoringReducer,
	asset: assetReducer,
	//audit: auditReducer,
	mbDashboard: mbdashboardReducer,
	mbUsage: mbUsageReducer,
	managedBackup: managedbackupReducer,
	alertingTools: alertingToolsReducer,
	alienVault: alienVaultReducer,
	apiKey: apiKeyReducer,
	assessments: assessmentsReducer,
	auth: authReducer,
	jiraTickets: jiraTicketsReducer,
	customer: customerReducer,
	graphapi: graphapiReducer,
	vulnerabilityScans: vulnerabilityScansReducer,
	vmTemplate: vmTemplateReducer,
	virtualMachine: vmReducer,
	user: userReducer,
	site: sitesReducers,
	sharepoint: sharepointReducer,
	services: servicesReducer,
	sentinelOne: sentinelOneReducer,
	role: roleReducer,
	roleMembership: roleMembershipReducer,
	resource: resourceReducer,
	resourcePermissions: resourcePermissionReducer,
	redirect: redirectReducer,
	quickbooks: quickbooksReducer,
	privateNetwork: privateNetworkReducer,
	orders: orderReducer,
	oneServer: oneServerReducer,
	alertEmailRecipients: alertEmailRecipientsReducer,
	powerbi: powerbiReducer,
	alerts: alertReducer,
	permissions: rbacReducer,
	permissionsStorage: permissionsReducer,
	virtualRouter: virtualRouterReducer,
	kubernetes: K8,
	companyNotifications: companyNotificationsReducers,
	publicNetworks: publicNetworksSlice,
	inventory: inventoryReducer,
	exabeam: exabeamReducer,
	onboarding: onboardingReducer,
	ticketNotificationScheme: ticketNotificationSchemeSlice,
	skus: skusReducer,
	gpuOne: gpuOneReducer,
	// RTK Query API slices
	[auditApi.reducerPath]: auditApi.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

let middleware = [];

if (import.meta.env.NODE_ENV === 'development') {
	const { createLogger } = require('redux-logger');
	const log = createLogger();
	middleware = [...middleware, log];
}

const store = configureStore({
	reducer: persistedReducer,
	middleware: getDefaultMiddleware => {
		let middlewareArray = getDefaultMiddleware({
			serializableCheck: false,
			immutableCheck: false,
		});
		middlewareArray = [...middlewareArray, ...middleware, auditApi.middleware];
		return middlewareArray;
	},
});

export const persistor = persistStore(store);

export default store;
